import { Stack, Typography } from '@deltasierra/react-components-core';
import { Image01 } from '@deltasierra/react-icons';
import { theme } from '@deltasierra/react-theme';

export const AssetLibraryGalleryEmpty = ({ message }: { message: string }): JSX.Element => (
    <Stack
        alignItems="center"
        data-cy="asset-library-empty-state"
        display="flex"
        height="100%"
        justifyContent="center"
        spacing={2}
        sx={{
            minHeight: { sm: '50vh', xs: '40vh' },
            path: { strokeWidth: 1 },
            width: 1,
        }}
    >
        <Image01 height={100} style={{ color: theme.palette.grey[500] }} width={100} />
        <Typography sx={{ fontSize: 16, maxWidth: '80%', textAlign: 'center', whiteSpace: 'pre-line' }} variant="body2">
            {message}
        </Typography>
    </Stack>
);

AssetLibraryGalleryEmpty.displayName = 'AssetLibraryGalleryEmpty';
